import {decodeEntities} from '@wordpress/html-entities';
import {SelectControl} from '@wordpress/components';
import {SetAttributes} from './Edit';
import {__} from '@wordpress/i18n';
import {CONFIG} from '../../../globals/config';

export type TaxonomyOptions = {
	taxonomy: string;
}

type Props = {
	attributes: TaxonomyOptions;
	setAttributes: SetAttributes;
};

const Taxonomy = ( {attributes, setAttributes}: Props ) => {
	// If we only have "Categories" we don't render the select.
	if ( 0 === Object.keys( CONFIG.taxonomies ).length ) {
		return null;
	}

	return (
		<SelectControl
			label={__( 'Taxonomy', 'advanced-sidebar-menu' )}
			labelPosition={'side'}
			value={attributes.taxonomy}
			options={Object.entries( CONFIG.taxonomies ).map( ( [ value, label ] ) => ( {
				value,
				label: decodeEntities( label ),
			} ) )}
			onChange={value => {
				setAttributes( {
					taxonomy: value,
				} );
			}} />
	);
};

export default Taxonomy;
